import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import RequestDetails from './RequestDetails';
import RequestDetailsTabState from './RequestDetailsTabState';

export default class RequestDetailsTabView extends BufferTabView<RequestDetailsTabState> {
  render(): this {
    const props = {
      requestId: this.model.get('requestId'),
    };
    renderToDOM(<RequestDetails {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<RequestDetailsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
